import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { IPortalNoteModel } from '@apps-common/types/portal/portal-note'

export const deletePortalNote = async (id: number): Promise<IPortalNoteModel> =>
  axios.delete(`/portalnotes/deletenote?noteId=${id}`).then((res) => res?.data?.data)

type Props = {
  id: number
}

export const useDeletePortalNote = (notify?: boolean, onSuccess?: (data: IPortalNoteModel) => void) =>
  useMutation({
    mutationKey: ['deletePortalNote'],
    mutationFn: ({ id }: Props) => deletePortalNote(id),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Deleted note.')
      }
    },
    onError: () => {
      if (notify) {
        toastError('Failed to delete note, please try again.')
      }
    },
    throwOnError: false
  })
